import { typedWindow } from '../Window';

class HotJar {
  identify(userId: string | null) {
    if (typedWindow.hj) {
      typedWindow.hj('identify', userId, {});
    }
  }

  tagRecording(tags: string[]) {
    if (typedWindow.hj) {
      typedWindow.hj('tagRecording', tags);
    }
  }
}

const hotjar = new HotJar();
export default hotjar;
